import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM } from './ter-protobomp-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';
import { MINUS, SPACE, TAB_CHARACTER } from '../utils/frfr-string-consts';
import { ROUND, ROUNDDOWN, XIF } from '../utils/excel-functions-utils';


export const derDraftel_terkk_nrr_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_nrr.default_preset_state(),
    /*
    flag_dvevelicine: virtel_k.flag_dvevelicine,
    ksirinaoznaka: virtel_k.ksirinaoznaka,
    kvisinaoznaka: virtel_k.kvisinaoznaka,
    ksirina2oznaka: virtel_k.ksirina2oznaka,
    kvisina2oznaka: virtel_k.kvisina2oznaka,
    brojmodula: virtel_m.brojmodula,
    */
    // NOVO // NJ 2024-10-07:
    tipkomore: virtel_k.tipkomore,
    vrstaprofila: virtel_k.vrstaprofila,
    // msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    // mvisinaunutrasnjaizmedjukrilaca: virtel_m.mvisinaunutrasnjaizmedjukrilaca,
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja,
    duzinamodula: virtel_m.duzinamodula,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_nrr_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let nrr_materijal_lim_tanji = null;
  let nrr_materijal_lim_deblji = null;
  if (tipmetalalima === "pocinkovani") {
    nrr_materijal_lim_tanji = _cpci.nrr_materijal_lim_pocinkovani_tanji;
    nrr_materijal_lim_deblji = _cpci.nrr_materijal_lim_pocinkovani_deblji;
  }
  if (tipmetalalima === "prohrom") {
    nrr_materijal_lim_tanji = _cpci.nrr_materijal_lim_prohrom_tanji;
    nrr_materijal_lim_deblji = _cpci.nrr_materijal_lim_prohrom_deblji;
  }
  //
  return {
    tipmetalalima,
    nrr_materijal_lim_tanji,
    nrr_materijal_lim_deblji,
  };
};


// izracunavanje sirina i visine na osnovu pods_input
export const _derivat_terkk_nrr_izracunaj_prvo = (state, pods_input) => {
  //
  const {
    // tipkomore,
    vrstaprofila,
    msirinaspoljasnja,
    mvisinaspoljasnja,
    duzinamodula,
  } = pods_input;
  const {
    nrr_tipkomore,
  } = state;
  //
  /*
  Širina komore - Ova vrednost se nasleđuje od modula i pretstavlja parametar $msirinaspoljasnja
  Preporučena visina donje sekcije - vrednost se nasleđuje od modula, parametar $mvisinaspoljasnja
  Visina donje sekcije-Ovaj parametar se unosi ručno,
  Preporučena visina gornje sekcije - vrednost se nasleđuje od modula, parametar $mvisinaspoljasnja
  Visina gornje sekcije-Ovaj parametar se unosi ručno,
  Dužina sekcije (Spoljašnje mere)- Ovaj podatak se nasleđuje od modula i predstavlja $duzinamodula /n
  Profil-nasleđuje se od komore $vrstaprofila
  Visina rekuperatora-Ovaj parametar se unosi ručno
  Debljina rekuperatora
  Broj komada- Unosi se manuelno
  Stavke koje se nasleđuju treba da budu osenčene i da ne mogu da se menjaju osim u pods_input.
  */
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  let nrr_sirinakomore = msirinaspoljasnja;
  // let nrr_visinadonjesekcije_preporucena = mvisinaspoljasnja;
  // let nrr_visinagornjesekcije_preporucena = mvisinaspoljasnja;
  // let nrr_visinadonjesekcije_preporucena = (mvisinaspoljasnja / 2) - 1; // NJ 2025-02-28: Vrednosti u ovim poljima potrebno je da budu ($mvisinaspoljasnja/2)-1
  // let nrr_visinadonjesekcije_preporucena = ROUNDDOWN((mvisinaspoljasnja / 2) - 1, 0); // NJ 2025-03-18 Zaokružiti na 0 decimala sa ROUNDDOWN
  // let nrr_visinagornjesekcije_preporucena = (mvisinaspoljasnja / 2) - 1;
  let nrr_visinadonjesekcije_preporucena = ROUNDDOWN((mvisinaspoljasnja / 2), 0); // NJ 2025-03-19: izbacujemo umanjenje za 1mm.
  // let nrr_visinagornjesekcije_preporucena = ROUNDDOWN((mvisinaspoljasnja / 2) - 1, 0); // NJ 2025-03-18 Zaokružiti na 0 decimala sa ROUNDDOWN
  let nrr_visinagornjesekcije_preporucena = ROUNDDOWN((mvisinaspoljasnja / 2), 0); // NJ 2025-03-19: izbacujemo umanjenje za 1mm.
  let nrr_duzinasekcijespoljasnjamera = duzinamodula; // Dužina sekcije (Spoljašnje mere)- Ovaj podatak se nasleđuje od modula i predstavlja $duzinamodula /n
  //
  return {
    tervrstaprofila_50_ili_70,
    nrr_sirinakomore,
    nrr_visinadonjesekcije_preporucena,
    nrr_visinagornjesekcije_preporucena,
    nrr_duzinasekcijespoljasnjamera,
  };
};


// izracunavanje za wiz step 2
export const _derivat_terkk_nrr_izracunaj_abcde = (state, pods_input) => {
  //
  const {
  } = pods_input;
  const {
    tervrstaprofila_50_ili_70,
    nrr_sirinakomore,
    nrr_visinadonjesekcije,
    nrr_visinagornjesekcije,
    nrr_duzinasekcijespoljasnjamera,
    nrr_visinarekuperatora,
    nrr_debljinarekuperatora,
  } = state;
  //
  //
  let nrr_b = null;
  if (tervrstaprofila_50_ili_70 === '50') {
    nrr_b = nrr_sirinakomore - 102;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    nrr_b = nrr_sirinakomore - 112;
  }
  //
  /*
  NJ 2024-12-24: H2=
  IF $vrstaprofila = 50 THEN ($visinagornjesekcije-140)+90 
  ELSE
  IF $vrstaprofila = 70 THEN ($visinagornjesekcije-180)+125
  */
  let nrr_h2 = null;
  if (tervrstaprofila_50_ili_70 === '50') {
    nrr_h2 = (nrr_visinagornjesekcije - 140) + 90;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    nrr_h2 = (nrr_visinagornjesekcije - 180) + 125;
  }
  //
  /*
  NJ 2024-12-24: H1=
  IF $vrstaprofila = 50 THEN ($visinadonjesekcije-140)+90 
  ELSE
  IF $vrstaprofila = 70 THEN ($visinadonjesekcije-180)+125
  */
  let nrr_h1 = null;
  if (tervrstaprofila_50_ili_70 === '50') {
    nrr_h1 = (nrr_visinadonjesekcije - 140) + 90;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    nrr_h1 = (nrr_visinadonjesekcije - 180) + 125;
  }
  //
  // C=(H1-$visinarekuperatora/2)-5
  const nrr_c = (nrr_h1 - nrr_visinarekuperatora / 2) - 5;
  //
  let nrr_l = null;
  if (tervrstaprofila_50_ili_70 === '50') {
    nrr_l = (nrr_duzinasekcijespoljasnjamera - 100);
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    nrr_l = (nrr_duzinasekcijespoljasnjamera - 110);
  }
  //
  // D=(L-$debljinarekuperatora-3)/2
  const nrr_d = (nrr_l - nrr_debljinarekuperatora - 3) / 2;
  //
  // E=(H2-$visinarekuperatora/2)-5
  const nrr_e = (nrr_h2 - nrr_visinarekuperatora / 2) - 5;
  //
  // G=$debljinarekuperatora+1 // izmenjeno: bilo je -1 u formuli, potrebno je +1
  const nrr_g = nrr_debljinarekuperatora + 1;
  //
  //
  return {
    nrr_b: ROUND(nrr_b, 2),
    nrr_c: ROUND(nrr_c, 2),
    nrr_d: ROUND(nrr_d, 2),
    nrr_e: ROUND(nrr_e, 2),
    nrr_g: ROUND(nrr_g, 2),
    nrr_h1: ROUND(nrr_h1, 2),
    nrr_h2: ROUND(nrr_h2, 2),
    nrr_l: ROUND(nrr_l, 2),
  };
};


//
export const _derivat_terkk_nrr_solidworks_export_string_make = (state) => {
  const {
    nrr_visinarekuperatora,
    nrr_debljinarekuperatora,
    nrr_b,
    nrr_c,
    nrr_d,
    nrr_e,
    nrr_g,
    nrr_h1,
    nrr_h2,
    nrr_l,
    nrr_sirinakomore,
    nrr_visinagornjesekcije,
    nrr_visinadonjesekcije,
    tervrstaprofila_50_ili_70,
    //
    tipmetalalima,
    nrr_materijal_lim_tanji,
    nrr_materijal_lim_deblji,
  } = state;
  //
  let ident = '?';
  /*
  Potrebno je dodati i formu za SolidWorks sa sledećim rasporedom:
  Ident B H H1 H2 A C D E F G L
  za Ident koristimo CNC program bez dodatka broja elementa "-P1"
  Oznake povezujemo sa oznakama parametara, dodaću parametre koje nemamo:
  H=H1+H2
  A- Predstavlja visinu rekuperatora
  F-predstavlja debljinu rekuperatora
  */
  if (true) {
    //
    let _materijal = '?';
    /*
    const _mat_params = _getParamsFromLibMaterijalLimParams(nrr_materijal_lim_tanji);
    const _tipmetalalima = _mat_params?.naziv_materijala;
    if (_tipmetalalima === "Prohrom") {
      _materijal = "SS";
    }
    if (_tipmetalalima === "Pocinkovani") {
      _materijal = "GS";
    }
    */
    if (tipmetalalima === "prohrom") {
      _materijal = "SS";
    }
    if (tipmetalalima === "pocinkovani") {
      _materijal = "GS";
    }
    //
    ident = "P01-14-B-" + nrr_sirinakomore + MINUS + nrr_visinagornjesekcije + nrr_visinadonjesekcije + MINUS + nrr_debljinarekuperatora + nrr_visinarekuperatora + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal;
  }
  const H = nrr_h1 + nrr_h2;
  const A = nrr_visinarekuperatora;
  const F = nrr_debljinarekuperatora;
  //
  //
  const arr_to_export = [
    ident,
    nrr_b,
    H,
    nrr_h1,
    nrr_h2,
    A,
    nrr_c,
    nrr_d,
    nrr_e,
    F,
    nrr_g,
    nrr_l,
  ];
  const string_to_export = arr_to_export.join(TAB_CHARACTER);
  return string_to_export;
};


//
export const _derivat_terkk_nrr_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    nrr_sirinakomore,
    nrr_debljinarekuperatora,
    nrr_visinarekuperatora,
    nrr_visinagornjesekcije,
    nrr_visinadonjesekcije,
    nrr_b,
    nrr_c,
    nrr_d,
    nrr_e,
    nrr_g,
    nrr_h1,
    nrr_h2,
    nrr_l,
    //
    tervrstaprofila_50_ili_70,
    nrr_materijal_lim_tanji,
    nrr_materijal_lim_deblji,
    duzinamodula,
  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$nrr/SKLOP_NRR') {
      /*
      Naziv: "NOSAC ROTACIONOG REKUPERATORA R:" $DebljinaRekuperatora"X"$VisinaRekuperatora" K:"$sirinakomore"X"$visinakomore -//Ispravka 03.12.2024. urađena je ispravka nije potreban parametar $Brojmodula
      Primer: NOSAC ROTACIONOG REKUPERATORA R:290X1220 K1:1330X1580

      Količina: 1
      Jedinica mere: KOM
      Operacija 1: Sklapanje (OPSKL)
      Radni centar 1: GRC-Finalizacija (GRCFIN)
      */
      item.distinction_key = "terkk$NRR/SKLOP_NRR"; // DIRTY
      const H = nrr_h1 + nrr_h2;
      _naziv = "NOSAC ROTACIONOG REKUPERATORA R:" + nrr_debljinarekuperatora + "x" + nrr_visinarekuperatora + " K:" + nrr_sirinakomore + "x" + H; //
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSKL"; // DIRTY
      item.rc1 = "GRCFIN"; // DIRTY
      //
      item.nrr_sirinakomore = nrr_sirinakomore; // DIRTY
      item.nrr_visinadonjesekcije = nrr_visinadonjesekcije; // DIRTY
      item.nrr_visinagornjesekcije = nrr_visinagornjesekcije; // DIRTY
      item.duzinamodula = duzinamodula; // DIRTY
      item.nrr_visinarekuperatora = nrr_visinarekuperatora; // DIRTY
      item.nrr_debljinarekuperatora = nrr_debljinarekuperatora; // DIRTY
      item.tervrstaprofila_50_ili_70 = tervrstaprofila_50_ili_70; // DIRTY
    }
    //
    if (family === 'terkk$nrr/P1') { // 2. P1
      /*
      CNC crtež:
      "P01-14-B-"$SirinaKomore"-"$visinagornjesekcije$visinadonjesekcije"-"$debljinarekuperatora$visinarekuperatora"-"$vrstaprofila (IF P70 THEN 70 ELSE p50 THEN 50)"-"$materijal(SS za prohromski lim, GS za pocinkovani lim)"-P1"
      */
      item.distinction_key = "terkk$NRR/P1"; // DIRTY
      _naziv = "NOSAC ROTACIONOG REKUPERATORA-P1-DONJI"; //
      item.kolicina = 2; // DIRTY
      item.dimenzija1 = nrr_b; // DIRTY
      item.dimenzija2 = nrr_c; // DIRTY
      item.razvijenamera1 = nrr_b + 94; // DIRTY
      item.razvijenamera2 = nrr_c + 125.2; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = nrr_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-14-B-" + nrr_sirinakomore + MINUS + nrr_visinagornjesekcije + nrr_visinadonjesekcije + MINUS + nrr_debljinarekuperatora + nrr_visinarekuperatora + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal + "-P1";
    }
    //
    if (family === 'terkk$nrr/P2') { // 3. P2
      /*
      CNC crtež:
      "P01-14-B-"$SirinaKomore"-"$visinagornjesekcije$visinadonjesekcije"-"$debljinarekuperatora$visinarekuperatora"-"$vrstaprofila (IF P70 THEN 70 ELSE p50 THEN 50)"-"$materijal(SS za prohromski lim, GS za pocinkovani lim)"-P2"
      */
      item.distinction_key = "terkk$NRR/P2"; // DIRTY
      _naziv = "NOSAC ROTACIONOG REKUPERATORA-P2-GORNJI"; //
      item.kolicina = 2; // DIRTY
      item.dimenzija1 = nrr_b; // DIRTY
      item.dimenzija2 = nrr_e; // DIRTY
      item.razvijenamera1 = nrr_b + 94; // DIRTY
      item.razvijenamera2 = nrr_e + 125.2; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = nrr_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-14-B-" + nrr_sirinakomore + MINUS + nrr_visinagornjesekcije + nrr_visinadonjesekcije + MINUS + nrr_debljinarekuperatora + nrr_visinarekuperatora + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal + "-P2";
    }
    //
    if (family === 'terkk$nrr/P3') { // 4. P3
      /*
      "P01-14-B-"$SirinaKomore"-"$visinagornjesekcije$visinadonjesekcije"-"$debljinarekuperatora$visinarekuperatora"-"$vrstaprofila (IF P70 THEN 70 ELSE p50 THEN 50)"-"$materijal(SS za prohromski lim, GS za pocinkovani lim)"-P3"
      */
      item.distinction_key = "terkk$NRR/P3"; // DIRTY
      _naziv = "NOSAC ROTACIONOG REKUPERATORA-P3-SPOJNICA"; //
      // item.kolicina = 2; // DIRTY
      /*
      Broj komada:
      
      IF(M13>200;
      (ROUND(((H13-150)/550+1);0)*2)-1;ROUND(((H13-150)/550+1);0)
      )+
      IF(O13>200;
      (ROUND(((H13-150)/550+1);0)*2)-1;ROUND(((H13-150)/550+1);0
      )))
      
      Gde su:
      M13-parametar C
      H13- Parametar B
      O13 - Parametar E /// Izmena 12.12.2024 nije postojala logika za količinu.
      */
      const M13 = nrr_c;
      const H13 = nrr_b;
      const O13 = nrr_e;
      item.kolicina = XIF(M13 > 200, (ROUND(((H13 - 150) / 550 + 1), 0) * 2) - 1, ROUND(((H13 - 150) / 550 + 1), 0)
      ) + XIF(O13 > 200, (ROUND(((H13 - 150) / 550 + 1), 0) * 2) - 1, ROUND(((H13 - 150) / 550 + 1), 0)); // DIRTY
      //
      item.dimenzija1 = nrr_g; // DIRTY
      item.dimenzija2 = 60; // DIRTY
      item.razvijenamera1 = nrr_g + 31.6; // DIRTY
      item.razvijenamera2 = 81.6; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = nrr_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-14-B-" + nrr_sirinakomore + MINUS + nrr_visinagornjesekcije + nrr_visinadonjesekcije + MINUS + nrr_debljinarekuperatora + nrr_visinarekuperatora + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal + "-P3";
    }
    //
    if (family === 'terkk$nrr/P4') { // 5. P4
      /*
      Dužina:
      B
      Dim. 2
      D
      Razvijena 1
      G+24.62
      Razvijena 2
      D+31,6
      
      CNC crtež:
      "P01-14-B-"$SirinaKomore"-"$visinagornjesekcije$visinadonjesekcije"-"$debljinarekuperatora$visinarekuperatora"-"$vrstaprofila (IF P70 THEN 70 ELSE p50 THEN 50)"-"$materijal(SS za prohromski lim, GS za pocinkovani lim)"-P4"
      */
      item.distinction_key = "terkk$NRR/P4"; // DIRTY
      _naziv = "NOSAC ROTACIONOG REKUPERATORA-P4-BOCNI"; //
      item.kolicina = 2; // DIRTY
      item.dimenzija1 = nrr_b; // DIRTY
      item.dimenzija2 = nrr_d; // DIRTY
      item.razvijenamera1 = nrr_b + 24.62; // DIRTY
      item.razvijenamera2 = nrr_d + 31.6; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = nrr_materijal_lim_tanji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-14-B-" + nrr_sirinakomore + MINUS + nrr_visinagornjesekcije + nrr_visinadonjesekcije + MINUS + nrr_debljinarekuperatora + nrr_visinarekuperatora + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal + "-P4";
    }
    //
    if (family === 'terkk$nrr/P5') { // 6. P5
      /*
      CNC crtež:
      "P01-14-B-"$SirinaKomore"-"$visinagornjesekcije$visinadonjesekcije"-"$debljinarekuperatora$visinarekuperatora"-"$vrstaprofila (IF P70 THEN 70 ELSE p50 THEN 50)"-"$materijal(SS za prohromski lim, GS za pocinkovani lim)"-P5"
      */
      item.distinction_key = "terkk$NRR/P5"; // DIRTY
      _naziv = "NOSAC ROTACIONOG REKUPERATORA-P5-KLIZAC"; //
      item.kolicina = 4; // DIRTY // Za element P5 potrebno je promeniti količinu sa 2 na 4
      item.dimenzija1 = nrr_b; // DIRTY
      item.dimenzija2 = 51; // DIRTY
      item.razvijenamera1 = nrr_b; // DIRTY
      item.razvijenamera2 = 78.4; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = nrr_materijal_lim_tanji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-14-B-" + nrr_sirinakomore + MINUS + nrr_visinagornjesekcije + nrr_visinadonjesekcije + MINUS + nrr_debljinarekuperatora + nrr_visinarekuperatora + MINUS + tervrstaprofila_50_ili_70 + MINUS + _materijal + "-P5";
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_nrr_izracunaj_za_step_protobomp = (state, pods_input) => {
  console.log('_derivat_terkk_nrr_izracunaj_za_step_protobomp state', state);
  //
  const {
    duzinamodula,
  } = pods_input;
  const {
    nrr_sirinakomore,
    nrr_debljinarekuperatora,
    nrr_visinarekuperatora,
    nrr_visinagornjesekcije,
    nrr_visinadonjesekcije,
    nrr_b,
    nrr_c,
    nrr_d,
    nrr_e,
    nrr_g,
    nrr_h1,
    nrr_h2,
    nrr_l,
    //
    tervrstaprofila_50_ili_70,
    nrr_materijal_lim_tanji,
    nrr_materijal_lim_deblji,
    kolicina,
  } = state;
  //

  // TODO
  const protobomp_superdata = {
    nrr_sirinakomore,
    nrr_debljinarekuperatora,
    nrr_visinarekuperatora,
    nrr_visinagornjesekcije,
    nrr_visinadonjesekcije,
    nrr_b,
    nrr_c,
    nrr_d,
    nrr_e,
    nrr_g,
    nrr_h1,
    nrr_h2,
    nrr_l,
    //
    tervrstaprofila_50_ili_70,
    nrr_materijal_lim_tanji,
    nrr_materijal_lim_deblji,
    duzinamodula,
  };

  //
  // 
  // let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$nrr"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_nrr_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$nrr/SKLOP_NRR',
    naziv: '* SKLOP NRR',
    kolicina: kolicina,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_NRR');
  const { created_tempkey: sklop_nrr } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //
  if (true) {
    //
    //
    if (true) { // 2. P1
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$nrr/P1',
        identmaterijala: nrr_materijal_lim_deblji,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nrr);
    }
    //
    if (true) { // 3. P2
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$nrr/P2',
        identmaterijala: nrr_materijal_lim_deblji,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nrr);
    }
    //
    if (true) { // 4. P3
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$nrr/P3',
        identmaterijala: nrr_materijal_lim_deblji,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nrr);
    }
    //
    if (true) { // 5. P4
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$nrr/P4',
        identmaterijala: nrr_materijal_lim_tanji,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nrr);
    }
    //
    if (true) { // 6. P5
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$nrr/P5',
        identmaterijala: nrr_materijal_lim_tanji,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nrr);
    }
    //

  }
  //
  //
  return {
    // _arr,
    _protobomp,
  };
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_nrr_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_nrr_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_nrr_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


